import React, { useState } from 'react';
import './DoubleSlider.css'; // Ensure to link the CSS file

const DoubleSlider = ({ min, max, onChange, rangeName, selectedElement, handleUnit  }) => {


  const [range, setRange] = useState([min, max]);

  const [unit, setUnit] = useState('');
  const [unitArray, setUnitArray] = useState([]);

  const frequency_unit = ["THz", "GHz", "MHz", "KHz", "Hz"];
  const wave_unit = ["km", "m", "cm", "mm", "µm", "nm", "pm", "fm"];

  const handleUnitChange = (event) => {
    const newUnit = event.target.value;
    setUnit(newUnit);
    handleUnit(newUnit);
  };

  const handleMinChange = (e) => {
    const newMin = e.target.value;
    const updatedRange = [newMin, range[1]];
    setRange(updatedRange);
    onChange([Number(newMin), Number(range[1])]);
  };

  const handleMaxChange = (e) => {
    const newMax = e.target.value;
    const updatedRange = [range[0], newMax];
    setRange(updatedRange);
    onChange([Number(range[0]), Number(newMax)]);
  };


  React.useEffect(() => {
    setRange([min, max]); // update internal state when props change
  }, [min, max]);

  React.useEffect(() => {
    if (selectedElement === 'Frequency') {
      setUnitArray(frequency_unit);
      setUnit("THz"); // default
      handleUnit("THz");
    } else {
      setUnitArray(wave_unit);
      setUnit("nm"); // default
      handleUnit("nm");
    }
  }, [selectedElement]);




  return (
    <div className="double-slider-container">
       <label htmlFor="element-value">{rangeName}</label>

       <div className="unit-selector">
  <label htmlFor="unit-select">Unit:</label>
  <select
    id="unit-select"
    value={unit}
    onChange={handleUnitChange}
    className="input-field-select"
  >
    {unitArray.map((u) => (
      <option key={u} value={u}>
        {u}
      </option>
    ))}
  </select>
</div>

      <div className="input-group">
        <div className="input-wrapper">
          <label htmlFor="min-input" className="input-label">Min Value:</label>
          <input
            type="text"
            id="min-input"
            value={range[0]}
            onChange={handleMinChange}
            className="input-field-slider"
          />
        </div>
        <div className="input-wrapper">
          <label htmlFor="max-input" className="input-label">Max Value:</label>
          <input
            type="text"
            id="max-input"
            value={range[1]}
            onChange={handleMaxChange}
            className="input-field-slider"
          />
        </div>
      </div>
    </div>
  );
};

export default DoubleSlider;
